import React, { useCallback, useMemo, useState } from 'react'
import { gql } from '@apollo/client'

import { useTranslation } from 'react-i18next'
import useAdminQuery from '../hooks/useAdminQuery'

import { PageHeader } from '../components/page-header'
import { PageBody } from '../components/page-body'
import SystemsReviewsFilter from '../components/reviews/your-reviews/filter'
import ReviewList from '../components/reviews/your-reviews/list'

import { FRAGMENT_REVIEW_TEXT } from '../constants/gql/systems'

const GET_SYSTEMS_NAV = gql`
  ${FRAGMENT_REVIEW_TEXT}

  query SystemsData($companyId: ID, $userId: ID, $systemId: ID) {
    appSystemsOnVendor(companyId: $companyId, userId: $userId, systemId: $systemId) {
      id
      systemSiteData {
        locale
        systemName
      }
      reviewData {
        ...ReviewTextsFragment
        parentReviewDataFor {
          ...ReviewTextsFragment
        }
      }
    }
  }
`

function SystemsReviewsPage() {
  const { t } = useTranslation(['content'])
  const [filteredSystemsReviews, setFilteredSystemsReviews] = useState(null)

  const {
    data: availableSystems,
    loading: availableSystemsLoading,
    refetch: refetchAvailableSystems
  } = useAdminQuery(GET_SYSTEMS_NAV)

  const allSystemsReviews = useMemo(() => {
    if (!availableSystems?.appSystemsOnVendor) {
      return []
    }

    return (
      availableSystems.appSystemsOnVendor.map((system) => {
        const sortedReviewData = [...system.reviewData].sort((a, b) => {
          return -a.created.localeCompare(b.created)
        })

        return {
          ...system,
          reviewData: sortedReviewData
        }
      }) || []
    )
  }, [availableSystems])

  const handleReviewChange = useCallback(() => {
    refetchAvailableSystems()
  }, [refetchAvailableSystems])

  return (
    <>
      <PageHeader pageName={t('reviews:header.title')} />

      <PageBody loading={availableSystemsLoading}>
        {!!allSystemsReviews?.length && (
          <SystemsReviewsFilter
            allSystemsWithReviews={allSystemsReviews}
            onReviewsFiltered={setFilteredSystemsReviews}
          />
        )}

        <ReviewList
          systemsWithReviews={filteredSystemsReviews}
          loading={availableSystemsLoading}
          onReviewsChanged={handleReviewChange}
        />
      </PageBody>
    </>
  )
}

export default SystemsReviewsPage
